import React from 'react'
import Cell from './Cell'
import { Tooltip } from '../../Tooltip'
import { FaInfoCircle } from 'react-icons/fa'
import infoToolFields from '../../../../utils/constants/widgets/infoToolFields'

export default ({ title }) => {
    const helper = infoToolFields.hasOwnProperty(title)
    const toolTipId = `${title}_${Math.random()}`
    return (
        <>
            <Cell value={title} type="string" />
            {helper && (
                <>
                    <span
                        data-tooltip-html={`${infoToolFields[title]}`}
                        data-tooltip-id={toolTipId}
                        className="icon formHelper"
                    >
                        <FaInfoCircle />
                    </span>
                    <Tooltip id={toolTipId} />
                </>
            )}
        </>
    )
}
